// src/components/dashboard/WelcomePanel.js
// Mini-strip compacta — substitui o card grande, liberando ~100px de espaço vertical

import React from 'react';
import { LogOut, Star, Coins, Lock } from 'lucide-react';
import { getTimeOfDayGreeting } from '../../utils/formatters';

export const WelcomePanel = ({ userName, onLogout, userProfile, onOpenPasswordModal }) => {
    const greeting = getTimeOfDayGreeting();
    const firstName = userName?.split(' ')[0] || '';

    return (
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm px-4 py-2.5 mb-4 flex items-center justify-between gap-4 flex-wrap">

            {/* Saudação compacta */}
            <div className="flex items-center gap-2.5 min-w-0">
                <div className="w-1 h-8 bg-[#C0181C] rounded-full flex-shrink-0" />
                <div className="min-w-0">
                    <p className="text-sm font-bold text-gray-400 uppercase tracking-widest leading-none">
                        {greeting}
                    </p>
                    <h1 className="text-xl font-black text-[#1B2B6B] leading-tight truncate">
                        {firstName}
                    </h1>
                </div>
            </div>

            {/* Saldos + ações */}
            <div className="flex items-center gap-1 flex-shrink-0">
                {/* Pontos */}
                <div className="flex items-center gap-1 px-3 py-1.5 bg-blue-50 rounded-lg">
                    <Star className="w-3.5 h-3.5 text-[#1B2B6B] fill-[#1B2B6B]" />
                    <span className="text-sm font-black text-[#1B2B6B]">
                        {(userProfile?.points || 0).toLocaleString('pt-BR')}
                    </span>
                    <span className="text-xs font-bold text-blue-400 ml-0.5 hidden sm:inline">pts</span>
                </div>

                {/* RPCoins */}
                <div className="flex items-center gap-1 px-3 py-1.5 bg-red-50 rounded-lg">
                    <Coins className="w-3.5 h-3.5 text-[#C0181C]" />
                    <span className="text-sm font-black text-[#C0181C]">
                        {(userProfile?.credits || 0).toLocaleString('pt-BR')}
                    </span>
                    <span className="text-xs font-bold text-red-300 ml-0.5 hidden sm:inline">rpc</span>
                </div>

                <div className="w-px h-6 bg-gray-200 mx-1" />

                {/* Alterar senha */}
                <button
                    onClick={onOpenPasswordModal}
                    className="p-1.5 text-gray-400 hover:text-[#1B2B6B] hover:bg-gray-100 rounded-lg transition-colors"
                    title="Alterar Senha"
                >
                    <Lock className="w-4 h-4" />
                </button>

                {/* Sair */}
                <button
                    onClick={onLogout}
                    className="flex items-center gap-1.5 bg-[#C0181C] hover:bg-red-700 text-white px-3 py-1.5 rounded-lg font-bold text-xs transition-colors shadow-sm"
                >
                    <LogOut className="w-3.5 h-3.5" />
                    <span className="hidden sm:inline">Sair</span>
                </button>
            </div>
        </div>
    );
};
